import CheckboxField from "./CheckboxField"

export default function SingleCheckbox({
    formik,
    name,
    label,
    disabled,
}) {
    const value = formik.values[name]
    const bridgedFormik = {
        ...formik,
        values: {
            ...formik.values,
            [name]: value ? { [name]: true } : {},
        },
        setFieldValue: (fieldName, fieldValue) => {
            if (fieldName === name) {
                const checked = !!fieldValue?.[name]
                formik.setFieldValue(name, checked)
                formik.setFieldTouched(name, true, false)
            } else {
                formik.setFieldValue(fieldName, fieldValue)
            }
        },
    }

    return (
        <CheckboxField
            formik={bridgedFormik}
            type="checkbox"
            name={name}
            options={[{ display: label, value: name }]}
            displayKey="display"
            valueKey="value"
            disabled={disabled}
        />
    )
}